import { defineSlotRecipe } from "@chakra-ui/react";

const tagSlotRecipe = defineSlotRecipe({
  slots: ["root", "startElement", "label", "endElement"],
  base: {
    root: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      bg: "gray.200",
      color: "gray.600",
      px: 2,
      py: 1,
      fontSize: "2xs",
      borderRadius: "md",
    },
    startElement: {
      alignItems: "center",
      justifyContent: "center",
      width: '12px',
      height: '12px',
      },
  },
});

export default tagSlotRecipe;